export enum KroUseCases {
  RELIGIOUS = "religious",
  CHARITY = "charity",
  PROJECTS = "projects",
  CLUB_AND_ASSOCIATIONS = "club_and_associations",
  MEDICAL = "medical",
  FINANCIAL_EMERGENCIES = "financial_emergencies",
}
